import { NgbDateParserFormatter, NgbDateAdapter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Injectable } from '@angular/core';
import { isNumber, toInteger, padNumber } from '@ng-bootstrap/ng-bootstrap/util/util';
import * as moment from 'moment';


export class NgbDateCustomParserFormatter extends NgbDateParserFormatter {
  //Parses the given value to an NgbDateStruct.
  //Implementations should try their best to provide a result, even partial. They must return null if the value can't be parsed.
  parse(value: string): NgbDateStruct {

    if(!value || value.indexOf('/') !== -1 || value.length < 8) { return null; }

    return {
      month: parseInt(value.substring(0,2), 10),
      day: parseInt(value.substring(2,4), 10),
      year: parseInt(value.substring(4), 10)
    };

  }

  //Formats the given date to a string.
  //Implementations should return an empty string if the given date is null, and try their best to provide a partial result if the given date is incomplete or invalid.
  format(date: NgbDateStruct): string {
    const pad = (n) => Number.isInteger(n) ? ('0' + n).substr(-2) : '';
    return date ? `${pad(date.month)}/${pad(date.day)}/${date.year}` : '';
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/dateParser.service.ts